'use strict';
var tealium = require('../../../int_tealium/cartridge/js/tealium/tealium'),
util = require('../../../app_fbb_core/cartridge/js/util');
var sessionAttributes = window.SessionAttributes;
var smsOptInModal = {
    calloutLocation: "",
    init: function(){
        window.smsOptModal = this;
		$(".smsSubscribeNow").on("click", function(e){
             $('.acquisitionKeyword').val($(this).attr('keyword'));
             if($(this).hasClass("vibes-megamenu") === true) {
                window.smsOptModal.calloutLocation = "Mega Menu";
             }
             else if($(this).hasClass("vibes-header") === true) {
                window.smsOptModal.calloutLocation = "Header";
             }
             else if($(this).hasClass("vibes-footer") === true) {
                window.smsOptModal.calloutLocation = "Footer";
             }
             else if($(this).hasClass("vibes-product-grid") === true) {
                window.smsOptModal.calloutLocation = "PLP";
             }
             else {
                window.smsOptModal.calloutLocation = "";
             }
             smsOptModal.open();
        });
        
		$("body").on('click','.modal.sms-opt-in .close',function(e){
			smsOptModal.close();
        });
        
		$("body").on("change", ".smsSignUp input[type=checkbox]", function(){
			var smsSubscription = $(this).closest('form').find('input[name$=_smsSignUp]').is(':checked');
			var checkoutInterceptor = $(this).closest('.guest-form').length > 0;
			var checkoutShipping = $(this).closest('.checkout-shipping').length > 0;
			var smsOptCookie = util.getCookie('guestsmsoptin'), optCookieValArray;
			var eventFired = '';
			
			if(smsOptCookie != "") {
				optCookieValArray = smsOptCookie.split('|');
				eventFired = optCookieValArray[2];
			}
			eventFired = eventFired != '' ? eventFired : 'false';
			
				if(!sessionAttributes.IS_CUSTOMER_AUTHENTICATED) {
					var name = 'guestsmsoptin', value='';
					var eventData = {};
					if(checkoutShipping) {
            			value = 'shipping_details';
						eventData.text_me_attempt_location = "shipping_details";
            		} else if(checkoutInterceptor) {
            			value = 'login_method';
						eventData.text_me_attempt_location = "login_method";
            		}
            		eventData.event_name = "text_me_attempt";			
					if(smsSubscription && eventFired == 'false') {
						tealium.triggerEvent(eventData);
						eventFired = 'true';
					}
					value = value + '|' + smsSubscription + '|' + eventFired;
					document.cookie = name+'='+value+'; path=/;secure';
				}
		});
        
        // ADA Compliance
        $(document).on("keydown", function(e){
            if($(".modal.sms-opt-in").length && $(".modal.sms-opt-in").hasClass("show")){
                if(e.keyCode > 36 && e.keyCode < 41){
                    $(".modal.sms-opt-in").find("input:visible, button:visible, a:visible").removeClass("focus-outline");
                }
            }
        });
        $("body").on('keyup', function(e) {            
            var isShiftKeyPressed = e.shiftKey;
            var isEscapeKeyPressed = e.key === "Escape";
            var target = document.activeElement;            
            if($(".modal.sms-opt-in").length && $(".modal.sms-opt-in").hasClass("show")){
                if($(target).closest(".modal.sms-opt-in").length === 0){    
                    $(".modal.sms-opt-in").find("input:visible, button:visible, a:visible").removeClass("focus-outline");                
                    var focusedElem = $(".modal.sms-opt-in").find("input:visible, button:visible, a:visible").eq(isShiftKeyPressed ? -1 : 0);
                    focusedElem.addClass("focus-outline");
                    focusedElem[0].focus();
                }
                if(isEscapeKeyPressed){
                    smsOptModal.close();
                }
            }        
        });
        // form handling
        $(".modal.sms-opt-in form").on("submit", function(e){
            e.preventDefault();
            $("#sms-opt-phone-no-value").text("");
            $(this).find("#sms-opt-phone-no").trigger("blur");
            if($(this).find("label.error").length === 0){               
                var acquisitionRequest = Urls.acquisitionRequest;
                var phoneNo = smsOptModal.phone.clean($(this).find("#sms-opt-phone-no").val());
                var keyword = $('.acquisitionKeyword').val();
                $.ajax({
                        type: 'POST',
                        url: acquisitionRequest,
                        data: { phoneNo: phoneNo, keyword: keyword },
                        success: function (response) {
                        	if(smsOptModal.tagEvent()){
								smsOptModal.tagEventResponse(response);
							}
                            if (typeof response === 'object' &&
                                !response.success && response.error === 'CSRF Token Mismatch') {
                                page.redirect(Urls.csrffailed);
                            } else if (response.success) {
                                if(response.errorStatus == false) {
                                    $("#sms-opt-phone-no-value").text($(".modal.sms-opt-in form").find("#sms-opt-phone-no").val());
                                    $(".modal.sms-opt-in").find("#default-body, #error-body").addClass("hide");
                                    $(".modal.sms-opt-in").find("#success-body").removeClass("hide");
                                    $(".modal.sms-opt-in").find("#success-body")[0].focus();
                                } else {
                                    var responseContainer = $('.modal.sms-opt-in .responseContainer');
                                    responseContainer.html(response.statusMessage ? response.statusMessage : "Unknown Error! Please try again later.");
                                    responseContainer[0].focus();
                                    $(".modal.sms-opt-in form label").addClass("error");
                                }
                            } else{
                                $(".modal.sms-opt-in").find("#default-body, #success-body").addClass("hide");
                                $(".modal.sms-opt-in").find("#error-body").removeClass("hide");
                                $(".modal.sms-opt-in").find("#error-body")[0].focus();
                            }
                    },
                    failure: function () {
                        $(".modal.sms-opt-in").find("#default-body, #success-body").addClass("hide");
                        $(".modal.sms-opt-in").find("#error-body").removeClass("hide");
                        $(".modal.sms-opt-in").find("#error-body")[0].focus();
                    }
                });
            }else{
            	 if(smsOptModal.tagEvent()){
            	 	var phoneNo = smsOptModal.phone.clean($(this).find("#sms-opt-phone-no").val().trim());
            	 	if(phoneNo != '') {
            	 		smsOptModal.invalidInputEvent();
            	 	}
            	 	else {
            	 		smsOptModal.blankInputEvent();
            	 	}
            	}  
                $(this).find("#sms-opt-phone-no").attr("data-silent", "true");              
                $(this).find("#sms-opt-phone-no")[0].focus();
                $(this).find("#sms-opt-phone-no").closest("label").addClass("error");
            }
        });
        // Custom Placeholder display logic
        $(".modal.sms-opt-in #sms-opt-phone-no").on("focus", function(){
            $(this).prev().addClass("active");
            $('.modal.sms-opt-in .responseContainer').html("");             
        }).on("input", function(){
            $(this).val(smsOptModal.phone.format($(this).val()));            
        }).on("focus keyup", function(e){
            var silentMode = $(this).attr("data-silent");
            if(!silentMode){
                var originalText = $(this).prev().attr("data-original-text");
                if(originalText){
                    $(this).prev().text( originalText );
                }
                $(this).closest("label").removeClass("error"); 
            }else{
                $(this).removeAttr("data-silent");
            }           
        }).on("blur", function(){
            var isError = false;
            var originalText = $(this).prev().attr("data-original-text");
            if(originalText){
                $(this).prev().text( originalText );
            }
            if($.trim($(this).val()) === ""){                    
                isError = true;
            }else{
                if($.trim($(this).val()).match(/^(\([0-9]{3}\)\s|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/) === null){
                    isError = true;
                    $(this).prev().attr("data-original-text", $(this).prev().text());
                    $(this).prev().text($(this).prev().attr("data-errors"));
                }
            }
            if(isError){                                       
                $(this).closest("label").addClass("error");
            }else{
                $(this).closest("label").removeClass("error");
            }
        });
    }, 
    open: function(){
        window.lastFocusedElem = document.activeElement;
        $(".modal.sms-opt-in").addClass("show").eq(0)[0].focus();
        // Trigger tealium link event, SC-10910, SC-11143
        if(smsOptModal.tagEvent()){
        	smsOptModal.modalInteraction();
        }
    },
    close: function(){
        $(".modal.sms-opt-in").removeClass("show");
        $(window.lastFocusedElem)[0].focus();
        smsOptModal.reset();
    },
    reset: function(){
        $('.modal.sms-opt-in .responseContainer').html("");
        $(".modal.sms-opt-in").find("#error-body, #success-body").addClass("hide");
        $(".modal.sms-opt-in").find("#default-body").removeClass("hide");
        $(".modal.sms-opt-in").find("#sms-opt-phone-no").val("").closest("label").removeClass("error").find("span").removeClass("active");
        var originalText = $(".modal.sms-opt-in").find("#sms-opt-phone-no").prev().attr("data-original-text");
        if(originalText){
            $(".modal.sms-opt-in").find("#sms-opt-phone-no").prev().text(originalText);
        }
    },
    modalInteraction : function() {
    	var eventData = {};
		eventData.event_name = "sms_modal";
    	smsOptModal.smsModalEvent(eventData);
    },
    blankInputEvent : function(){
    	var eventData = {};
		eventData.event_name = "sms_no_input";
    	smsOptModal.smsModalEvent(eventData);
    },
	invalidInputEvent : function(){
    	var eventData = {};
		eventData.event_name = "sms_invalid_number";
    	smsOptModal.smsModalEvent(eventData);
    },
    smsModalEvent : function(eventData){
		if(smsOptModal.isEmailEvent() == 'true') {
			eventData.sms_opt_in_location = "Email";
		}else if(smsOptModal.isConfirmationEvent() == 'true') {
			eventData.sms_opt_in_location = "order_confirmation";
        } else if (window.smsOptModal.calloutLocation.length > 0) {
            eventData.sms_opt_in_location = window.smsOptModal.calloutLocation;
        }
    	tealium.triggerEvent(eventData);
    },
    tagEvent : function(){
    	//Link Tag event is needed on email-redirect-modal and checkout confirmation pages. Add to event/page types need tealium tagging
    	var isEmailModal = smsOptModal.isEmailEvent();
    	var isConfirmationPage = smsOptModal.isConfirmationEvent();
    	
    	if(isEmailModal == 'true' || isConfirmationPage == 'true' || window.smsOptModal.calloutLocation.length > 0) {
    		return true;
    	}
    	return false;
    },
    tagEventResponse : function(response) {
		var eventData = {};
		var eventData = smsOptModal.getBasicEventData();
		
		if(response.success) {
			if(response.errorStatus == false) {
				eventData.event_name = "sms_registration";
				eventData.sms_opt_in_response = "Successful";
			} else if(response.errorCode == 400) {
				eventData.event_name = "sms_invalid_number";
			} else if(response.errorCode == 422) {
				eventData.event_name = "sms_carrier_not_supported";
			}else if(response.errorCode == 409) {
				eventData.event_name = "sms_already_registered";
			}
				
		} else {
			eventData.event_name = "sms_registration";
			eventData.sms_opt_in_response = "Unsuccessful";
		}
		tealium.triggerEvent(eventData);
    },
    getBasicEventData : function() {
    	var email_event, confirmation_event;
    	email_event = smsOptModal.isEmailEvent();
    	confirmation_event = smsOptModal.isConfirmationEvent();
    	var eventData = {};
    	if(email_event == 'true'){
    		eventData.sms_opt_in_location = "Email";
    	} else if(confirmation_event == 'true') {
    		eventData.sms_opt_in_location = "order_confirmation";
    	} else if (window.smsOptModal.calloutLocation.length > 0) {
            eventData.sms_opt_in_location = window.smsOptModal.calloutLocation;
        }
    	return eventData;
    },
    isEmailEvent : function() {
    	return $('.isEmailModal').length > 0 ? $('.isEmailModal').val() : 'false';
    },
    isConfirmationEvent : function(){
    	if(window.pageContext && window.pageContext.ns == 'orderconfirmation') {
    		return 'true';
    	} else {
    		return 'false';
    	}
    },
    phone: {
        format: function(input){
            return input.replace(/^[\s\t\r\n]/,"").replace(/[^0-9\s\(\)\-]/g,"").replace(/[\t\r\n]/g, "").replace(/^(\([0-9]{3})([0-9]{1})/,"$1) $2").replace(/^([0-9]{3})/,"($1) ").replace(/^\(([0-9]{3})\)\s([0-9]{3})/, "($1) $2").replace(/^\(([0-9]{3})\)\s([0-9]{3})([0-9]+)/, "($1) $2-$3").substring(0, 14);
        },
        clean: function(input){
            return input.replace(/[\-|\(\)\s]/g, "");
        }
    }
}

module.exports = smsOptInModal;